(function ($, window, undefined) {

	(function () {
		'use strict';

		/*
		 * Função utilizada para animar o banner com efeito falso de parallax
		 */
		if ($('.banner-interno').length > 0) {
			// Verificando se existe o atributo de parallax para fazer a animação
			var hasAttr = $('.banner-interno').attr('data-parallax');
			if (typeof hasAttr !== typeof undefined && hasAttr !== false) {
				// Realiza dinamicamente a animação ao fazer scroll
				$(window).on('scroll', function () {
					var element, position, scroll;
					return element = $('.banner-interno[data-parallax]'),
						element.length > 0 ?
						(scroll = -6, position = -window.pageYOffset / scroll, element.css({ backgroundPosition: 'center ' + position + 'px' })) : void 0;
				});
			}
		}

	})();

}(jQuery, window));
